import React from "react";
import SearchBar from "theme/modules/Search/SearchBar";

const SearchNavigation = () => {
  return (
    <div className="container">
      <SearchBar />
    </div>
  );
};

export default SearchNavigation;
